import { render } from "./BlockListPage.vue?vue&type=template&id=163c2d2e"
import script from "./BlockListPage.vue?vue&type=script&lang=js"
export * from "./BlockListPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__